<template>
  <BSkeletonWrapper
    :loading="loading"
  >
    <template #loading>
      <BCard>
        <BCardTitle>
          <div class="h6">
            <BSkeleton
              width="75%"
              height="23px"
            />
          </div>
        </BCardTitle>

        <BCardText>
          <div class="text-nowrap text-truncate">
            <BSkeleton
              width="100%"
              height="16px"
            />
          </div>
        </BCardText>

        <BCardText>
          <BContainer>
            <BRow>
              <BSkeletonImg
                height="200px"
                class="col-12 border border-light border-lg"
                no-aspect
              />
              <BSkeletonImg
                height="200px"
                class="col-6 border border-light border-lg"
                no-aspect
              />
              <BSkeletonImg
                height="200px"
                class="col-6 border border-light border-lg"
                no-aspect
              />
            </BRow>
          </BContainer>
        </BCardText>

        <BCardText>
          <slot name="footer-loader" />
        </BCardText>
      </BCard>
    </template>
    <BCard>
      <BCardText>
        <div class="d-flex flex-column justify-content-center mb-1">
          <div
            class="mt-1"
            style="font-size: 0.7rem;"
          >
            Held at <b>{{ details?.barangay_name }}, {{ details?.municipality_name }}, {{ details?.province_name }}</b>
          </div>
          <div
            style="font-size: 0.7rem;"
          >
            Last <b>{{ dateShortFormatter(details?.event_date) }}</b>
          </div>
        </div>
      </BCardText>

      <BCardText>
        <div
          class="text-nowrap text-truncate"
          style="font-size: 14px;"
        >
          {{ details?.remarks }}
        </div>
      </BCardText>

      <BCardText>
        <BContainer>
          <BRow
            v-if="attachments.length <= 0"
          >
            <BCol
              cols="12"
              :style="{
                backgroundImage: `url(/img/invalid-image.png)`,
                // backgroundImage: `url(${attachment.url})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                height: attachmentDivider(0).height
              }"
              class="border border-light border-lg"
            />
          </BRow>
          <BRow
            v-else
          >
            <BCol
              v-for="(attachment, index) in attachments.filter((_, i) => attachments.length <= 4 ? i <= 3 : i <= 2)"
              :key="index"
              :cols="attachmentDivider(index).cols"
              :style="{
                backgroundImage: `url(${attachmentUrl(attachment)})`,
                // backgroundImage: `url(${attachment.url})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                height: attachmentDivider(index).height,
                minHeight: attachmentDivider(index).height
              }"
              class="border border-light border-lg cursor-pointer"
              @click.prevent="$emit('show:attachment', index)"
            />
            <BCol
              v-if="attachments.length >= 5"
              cols="4"
              :style="{
                backgroundImage: `linear-gradient(0deg, rgba(100, 100, 100, 0.7), rgba(100, 100, 100, 0.5)), url(${attachmentUrl(attachments[3])})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                height: attachmentDivider(4).height,
                minHeight: attachmentDivider(4).height
              }"
              class="border border-light border-lg d-flex justify-content-center align-items-center"
            >
              <BButton
                variant="link"
                @click.prevent="$emit('more:attachments', { title, description, index })"
              >
                <h5 class="text-white font-weight-bold">
                  {{ attachments.length - 3 }}+ more
                </h5>
              </BButton>
            </BCol>
          </BRow>
        </BContainer>
      </BCardText>

      <BCardText>
        <slot name="footer" />
      </BCardText>
    </BCard>
  </BSkeletonWrapper>
</template>
<script>
import MxImageUrl from '@/mixins/image-url'
import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

export default {
  name: 'ASMOfficerTaskEventsEvent',

  mixins: [
    MxFormatter,
    MxMisc,
    MxImageUrl
  ],

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },
    details: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        province_name: '',
        municipality_name: '',
        barangay_name: '',
        customer_name: '',
        products: []
      })
    },
    attachments: {
      type: Array,
      required: true,
      default: () => []
    },
    attachmentPath: {
      type: String,
      required: true,
      default: () => ''
    }
  },

  emits: [
    'more:attachments',
    'show:attachment'
  ],

  methods: {

    attachmentUrl (file) {
      return this.transformToImageUrl(`${this.attachmentPath}/${file.file_hashed_name}`)
    },

    attachmentDivider (index) {
      const isMobile = this.isMobile()

      const smallerScreenWidth = isMobile ? '150px' : '200px'
      const largeScreenWidth = isMobile ? '300px' : '400px'

      switch (this.attachments.length) {
        case 1: {
          return {
            cols: 12,
            height: largeScreenWidth
          }
        }
        case 2: {
          return {
            cols: 12,
            height: smallerScreenWidth
          }
        }
        case 3: {
          if (Number(index) === 0) {
            return {
              cols: 12,
              height: smallerScreenWidth
            }
          }

          return {
            cols: 6,
            height: smallerScreenWidth
          }
        }
        default: {
          if (Number(index) === 0) {
            return {
              cols: 12,
              height: smallerScreenWidth
            }
          }

          return {
            cols: 4,
            height: smallerScreenWidth
          }
        }
      }
    }
  }
}
</script>
